
import { useEffect, useState } from 'react';
import CountUp from 'react-countup';

export default function EventDirection() {
  const [states, setStates] = useState([]);
  const wpUrl = process.env.REACT_APP_WP_URL;
  useEffect(() => {
    fetch(`${wpUrl}wp-json/custom/v1/states`)
      .then(res => res.json())
      .then(data => setStates(data))
      .catch(err => console.error('Error fetching states:', err));
  }, []);


  return (
    <>
      {/* Event Direction Start */}
      <section className="event-direction">
        <div className="container">
          <div className="event-direction__inner">
            <div className="row">
              <div className="col-xl-7 wow fadeInLeft" data-wow-delay="100ms">
                <div className="event-direction__left">
                  <div className="section-title text-left">
                    <div className="section-title__tagline-box">
                      <span className="section-title__tagline">Our Event Locations</span>
                    </div>
                    {/* <h2 className="section-title__title" dangerouslySetInnerHTML={{ __html: eventContent.title }}></h2> */}
                  </div>
                  {/* <p className="event-direction__text" dangerouslySetInnerHTML={{ __html: eventContent.text }}></p> */}
                  <div className="event-direction__call">
                
                  </div>
                </div>
              </div>
              <div className="col-xl-12 wow fadeInRight" data-wow-delay="300ms">
                <div className="event-direction__right">
                <div className="event-direction__counter list-unstyled ">
                    {states.map((state, index) => (
                      <div className="event-direction__counter-single col-xl-2 col-md-2" key={index}>
                        <a href={`/event?state=${encodeURIComponent(state.name)}`} className="event-direction__counter-box">
                          <h3 className="odometer">
                            <CountUp start={0} end={state.count} duration={2} />
                          </h3>
                        </a>
                        <p className="event-direction__counter-text">
                          {state.name}
                        </p>
                      </div>
                    ))}
                   
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Direction End */}
    </>
  );
}
